import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function changeTest(params) {
  const axios = axiosInstance().primoLab;
  let testWorkQueue = [];

  await axios
    .post(`/test-work-queues/change-test`, params)
    .then(async (response) => {
      testWorkQueue = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { testWorkQueue };
}

